/**
 * The detail page's follow state, shared with its sections (web plan W0.10).
 *
 * `EntityDetailLayout` owns the follow toggle (`useFollowToggle`: its header
 * button, the optimistic follower count, the cache update and the rollback).
 * It provides this context around its main column, so a section can offer the same
 * action — "No active offers right now — follow {Brand} for alerts" — and
 * both buttons always show one state. Null outside a loaded detail layout.
 */
import { createContext, useContext } from 'react';

export interface EntityFollowState {
  /** Whether the viewer follows the page's entity (optimistic). */
  subscribed: boolean;
  /** A toggle is in flight. */
  subscribing: boolean;
  /** The header button's action: a guest goes to /login, a member toggles. */
  toggleFollow: () => void;
}

export const EntityFollowContext = createContext<EntityFollowState | null>(null);

export function useEntityFollow(): EntityFollowState | null {
  return useContext(EntityFollowContext);
}
